module.exports = __webpack_public_path__ + "4d295621045bd774d4beed9d6d5796e4.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-MediumItalic.woff2
// module id = 977
// module chunks = 0